import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import { AgendaService } from 'src/app/pages/agenda/services/agenda.service';
import { EnumleaveTimeType } from 'src/app/pages/atestados/models/atestado';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { ESolicitacaoConsultaStatus, ISolicitacaoConsultaFiltros, IConsulta } from '../consultas/data/consultas';
import { IListByFilterMedico, IMedico } from '../doctors/models/doctor';
import { DoctorService } from '../doctors/services/doctor.service';

@Component({
  selector: 'app-historico-consultas',
  templateUrl: './historico-consultas.component.html',
  styleUrls: ['./historico-consultas.component.scss']
})
export class HistoricoConsultasComponent implements OnInit {
  ordenarControl = new UntypedFormControl(EOrdenacao.MaisNovos);
  acaoInput = new UntypedFormControl();
  doctorControl = new UntypedFormControl('');

  opcoesOrdenacao = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];

  doctors: IMedico[] = [];
  isDoctor = true;

  consultas: IConsulta[] = [];
  EnumLeaveType = EnumleaveTimeType;
  ESolicitacaoConsultaStatus = ESolicitacaoConsultaStatus;

  dadosPaginacao = {
    ordenacao: EOrdenacao.MaisNovos,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0,
    periodStart: 0,
    periodEnd: 0
  };

  showModalDetalhesConsulta = false;
  consultaSelected?: IConsulta;

  constructor(
    private readonly agendaService: AgendaService,
    private readonly doctorService: DoctorService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.isDoctor = this.sessionService.getSession().role === ERoleAdminString.Doctor;
    this.carregarConsultas();
    this.carregarMedicos();

    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarConsultas();
    });
  }

  filtrar(): void {
    this.carregarConsultas();
  }

  limparFiltros(): void {
    this.acaoInput.reset();
    this.carregarConsultas();
  }

  carregarConsultas(): void {
    const filtros: ISolicitacaoConsultaFiltros = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina),
      companyId: this.sessionService.getSession().companyId!,
      periodEnd: new Date().toISOString()
      //status: Number(this.ESolicitacaoConsultaStatus.Aceita),
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (this.isDoctor) {
      filtros.doctorId = this.sessionService.getSession().sid;
    } else if (this.doctorControl.value) {
      filtros.doctorId = this.doctorControl.value;
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }

    this.agendaService.carregarConsultasPaginadas(filtros).subscribe((res) => {
      this.consultas = res.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = res.count!;
    });
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;

    this.carregarConsultas();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacao.paginaSelecionada = 0;

    this.carregarConsultas();
  }

  public selecionarConsulta(consulta: IConsulta): void {
    this.consultaSelected = consulta;
    this.showModalDetalhesConsulta = true;
  }

  public hideModalConsulta(): void {
    this.showModalDetalhesConsulta = false;
  }

  private carregarMedicos(): void {
    if (!this.isDoctor) {
      const filtros: IListByFilterMedico = {
        orderBy: Number(this.dadosPaginacao.ordenacao),
        pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
        pageSize: 9999,
        active: true
      };

      const partnerId = this.sessionService.getSession().partnerId;
      const companyId = this.sessionService.getSession().companyId;
      const accountRole = this.sessionService.getSession().accountRole;

      if (partnerId) {
        filtros.partnerId = partnerId;
      }

      if (companyId) {
        filtros.companyId = companyId;
      }

      if (accountRole) {
        filtros.accountRole = parseInt(accountRole);
      }

      this.doctorService
        .listarTodosMedicos(filtros)
        .pipe(take(1))
        .subscribe((res) => {
          if (res.isSucceed) {
            this.doctors = res.data;
          }
        });
    }

    this.doctorControl.valueChanges.subscribe(() => {
      this.carregarConsultas();
    });
  }
}
